module.exports = __webpack_public_path__ + "static/media/S1.eced1c11.jpg";